module.exports = __webpack_public_path__ + "img/started_p.c14e4859.svg";